import { Alert, Button, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";

interface Props {
  caseId: string;
  showCaseLink?: boolean;
}

export default function LegacyTechnicalReportNotice({
  caseId,
  showCaseLink = true,
}: Props) {
  return (
    <Alert color="blue" title="Original technical report" role="status">
      <Stack gap="sm" align="flex-start">
        <Text size="sm">
          This TC case retains its original NovoPath Technical Summary.
          Pathology report reconstruction, addenda, amendments, and corrections
          are not available for this case.
        </Text>
        {showCaseLink && (
          <Button component={Link} to={`/cases/${caseId}`} variant="light">
            Open case and original Technical Summary
          </Button>
        )}
      </Stack>
    </Alert>
  );
}
